/* eslint-disable */
/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description: AI识别模块网络请求actions
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-10-19 16:37:19
 */
import { message } from 'antd'
import fetchHelper from '../utils/fetchHelper'
import { captureFetchException } from '../utils/sentryUtils'

/**
 * AI识别接口V2
 * @param {Object} data - 识别参数
 * @param {string} data.groupID - 团队ID
 * @param {string} data.url - 图片URL
 * @param {string} data.userID - 用户ID
 * @param {string} data.modelName - 模型名称
 * @param {object[]} data.user_choice - 用户选择的安全场景
 * @param {number[][]} data.bbox - 选择信息
 */
export function fetchAIRecognitionV2(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/recognition/v2',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // 返回包含msg的完整响应信息
        return Promise.resolve({
          data: result.data,
          msg: result.msg,
          code: result.code
        })
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('识别失败，请重试')
        return Promise.reject(err)
      })
  }
}

/**
 * AI识别接口
 * @param {Object} data - 识别参数
 * @param {string} data.groupID - 团队ID
 * @param {string} data.url - 图片URL
 * @param {string} data.userID - 用户ID
 * @param {string} data.modelName - 模型名称
 * @param {object[]} data.user_choice - 用户选择的安全场景
 * @param {number[][]} data.objs - 选择信息
 */
export function fetchAIRecognition(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/recognition',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // 返回包含msg的完整响应信息
        return Promise.resolve({
          data: result.data,
          msg: result.msg,
          code: result.code
        })
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('识别失败，请重试')
        return Promise.reject(err)
      })
  }
}

/**
 * 获取AI识别记录列表
 * @param {Object} data - 查询参数
 * @param {string} data.groupID - 团队ID
 * @param {number} data.pageNo - 页码
 * @param {number} data.pageSize - 页面大小
 * @param {number} [data.startTime] - 开始时间
 * @param {number} [data.endTime] - 结束时间
 */
export function fetchAIRecognitionList(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/list',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('获取识别记录失败')
        return Promise.reject(err)
      })
  }
}

/**
 * 更新AI识别结果
 * @param {Object} data - 更新参数
 * @param {string} data.groupID - 团队ID
 * @param {number} data.id - 记录ID
 * @param {string[]} data.potentialHazardList - 隐患列表
 * @param {string[]} data.standardList - 标准列表
 * @param {string} data.userID - 用户ID
 */
export function updateAIRecognitionResult(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/update',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('导出失败，请重试')
        return Promise.reject(err)
      })
  }
}

/**
 * 导出AI识别记录Excel
 * @param {Object} data - 导出参数
 * @param {string} data.groupID - 团队ID
 * @param {string} data.userID - 用户ID
 * @param {string} data.format - 导出格式
 * @param {number[]} data.ids - 记录ID列表
 * @param {string} [data.monomerName] - 组件名称（可选）
 * @param {string[]} [data.questionTypeList] - 问题类型列表（可选）
 * @param {string[]} [data.userIDList] - 用户ID列表（可选）
 * @param {string} [data.keywords] - 关键词（可选）
 */
export function exportAIRecognitionExcel(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/export',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('导出失败，请重试')
        return Promise.reject(err)
      })
  }
}

/**
 * 获取AI识别示例照片
 * @param {Object} data - 查询参数
 * @param {number} data.count - 照片数量
 */
export function fetchAIRecognitionExamplePhotos(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/photo/example',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        console.error('获取示例照片失败:', err)
        return Promise.reject(err)
      })
  }
}

/**
 * 安全场景识别接口
 * @param {Object} data - 识别参数
 * @param {string} data.modelName - 模型名称
 * @param {Array<Array<number>>} data.bbox - 框选区域数组，格式：[[x,y,width,height]]
 * @param {string} data.url - 图片地址
 */
export function fetchAIRecognitionObjs(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/recognition/objs',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('安全场景识别失败，请重试')
        return Promise.reject(err)
      })
  }
}

/**
 * 识别内容编辑
 * @param {Object} data - 编辑参数
 * @param {string} data.ConstructioUnit - 施工单位
 * @param {string} data.RectificationManager - 整改责任人
 * @param {string} data.RectificationMeasure - 整改措施
 * @param {string} data.comment - 备注
 * @param {string} data.deadline - 整改期限
 * @param {string} data.finishTime - 完成时间
 * @param {string} data.groupID - 组ID
 * @param {number} data.id - 记录ID
 * @param {string} data.monomerName - 单体名称
 * @param {string[]} data.photoFilesAfter - 整改后照片
 * @param {string[]} data.potentialHazardList - 隐患条目
 * @param {string} data.questionType - 问题类型
 * @param {string[]} data.standardList - 参考标准
 * @param {string} data.projectName - 用户ID
 * @param {string} data.monomerNameContent - 组件名称
 * @param {string} data.questionTypeContent - 问题类型
 * @param {string[]} data.potentialHazardListContent - 隐患条目
 * @param {string[]} data.standardListContent - 参考标准
 * @param {number} data.monitorType - 识别类型 0:llm 1:水印
 * @param {Array<{ name: string; val: number }>} data.hazardSourceList - 隐患生成支持的来源
 */
export function editAIRecognition(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/edit',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // 返回包含msg的完整响应信息
        return Promise.resolve({
          data: result.data,
          msg: result.msg,
          code: result.code
        })
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('编辑失败，请重试')
        return Promise.reject(err)
      })
  }
}

/**
 * AI重新识别接口
 * @param {Object} data - 重新识别参数
 * @param {number} data.id - 记录ID
 * @param {string[]} data.descContent - 描述内容数组
 * @param {string} data.groupID - 团队ID
 * @param {string} data.modelName - 模型名称
 * @param {string} data.url - 图片URL
 * @param {string} data.userID - 用户ID
 */
export function fetchAIRecognitionRecall(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/safemonitor/recognition/recall',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // 返回包含msg的完整响应信息
        return Promise.resolve({
          data: result.data,
          msg: result.msg,
          code: result.code
        })
      })
      .catch((err) => {
        captureFetchException(err, config)
        message.error('AI重新识别失败，请重试')
        return Promise.reject(err)
      })
  }
}
